import { Toast } from 'vant';
import Router from '@/router';
// import { CuccStatusType } from '@/model/CuccStatusType'
import sourceApi from '@/api/modules/source';
import { getConfig } from '@/api/modules/config';
import { CarrierType } from '@/model/CarrierType';
import { PackageStatusType } from '@/model/PackageStatusType';
import ProcessDialog from '@/components/processDialog';
import { parseUrlParams } from '@/utils/index';
import { track } from '@/directives/track/send.js';
import { checkMobile } from '@/api/modules/phone';
import { packageList } from '@/api/modules/telecom';
import { handleMIGUClose } from './ringtone/telecom';
import { queryTopic } from '@/api/modules/subject';
import { newLogin } from '@/api/modules/user';
import { failPost } from '@/api/modules/investmentflow';
const sensors = window.sensorsDataAnalytic201505;
const introduce = {
    namespaced: true,
    state: () => {
        return {
            carrierType: localStorage.getItem('userInfo') ? localStorage.getItem('userType') : CarrierType.MIGU,
            phone: localStorage.getItem('userInfo') ? JSON.parse(localStorage.getItem('userInfo') || '').phone : '',
            // 订购所需数据
            settingData: {
                videoId: '',
                productId: '',
                copyRightID: '',
                contentId: '',
                sourceType: '',
                songName: '',
                actorName: '',
                channelName: '',
                desc: ''
            },
            showList: [],
            showCuccList: [],
            errorMessage: '',
            showMessage: ''
        };
    },
    mutations: {
        SET_SHOW_MESSAGE: (state, showMessage) => {
            state.showMessage = showMessage;
        },
        SET_ERROR_MESSAGE: (state, errorMessage) => {
            state.errorMessage = errorMessage;
        },
        // 运营商
        SET_CARRIER_TYPE: (state, data) => {
            state.carrierType = data;
            window.localStorage.setItem('userType', data);
        },
        // 当前使用的手机号
        SET_PHONE: (state, data) => {
            // 如果清除了 则将手机号设置为一键登录的手机号
            if (!data && state.oneClickPhone) {
                state.phone = state.oneClickPhone;
            }
            else {
                state.phone = data;
            }
        },
        // 设置彩铃信息
        SET_SETTING_DESC(state, desc) {
            state.settingData.desc = desc;
        },
        SET_SETTING_SOURCETYPE(state, sourceType) {
            state.settingData.sourceType = sourceType;
        },
        SET_SETTING_VIDEOID(state, ringId) {
            state.settingData.videoId = ringId;
        },
        SET_SETTING_PRODUCT_ID(state, productId) {
            state.settingData.productId = productId;
        },
        SET_SETTING_CONTENT_ID(state, contentId) {
            state.settingData.contentId = contentId;
        },
        SET_SETTING_CROPYRINGHT_ID(state, copyRightID) {
            state.settingData.copyRightID = copyRightID;
        },
        SET_SHOWLIST(state, showList) {
            state.showList.splice(0);
            state.showList.push(...showList);
        },
        SET_CUCC_SHOWLIST(state, showList) {
            state.showCuccList.splice(0);
            state.showCuccList.push(...showList);
        }
    },
    actions: {
        getCuccList({ commit }, payload) {
            getConfig().then(() => {
                // const id = res.data.telecom_xinxiliu_subject
                sourceApi
                    .queryTopic({ subjectId: payload, phone: '13161770390', sourceType: 2 })
                    .then((res) => {
                    commit('SET_CUCC_SHOWLIST', res.data.ringContentVOList.map((item) => {
                        return {
                            sourceType: item.ispType,
                            id: item.ringId,
                            desc: item.ringName,
                            homePosterSrc: item.homePreviewPath,
                            title: item.ringName,
                            posterSrc: item.homePreviewPath,
                            videoSrc: item.filePath
                        };
                    }));
                })
                    .catch((err) => { console.log(err); });
            });
        },
        getTelecomListNew({ commit }, id) {
            return new Promise((resolve, reject) => {
                getConfig().then((res1) => {
                    queryTopic({ subjectId: id, phone: '17310075030' })
                        .then((res) => {
                        resolve(res1.data);
                        commit('SET_SHOW_MESSAGE', res.data.backGroundColor);
                        commit('SET_SHOWLIST', res.data.ringContentVOList.filter((i) => i.ispType === 1).map((item) => {
                            return {
                                sourceType: item.ispType,
                                id: item.ringId,
                                desc: item.ringName,
                                homePosterSrc: item.homePreviewPath,
                                title: item.ringName,
                                posterSrc: item.homePreviewPath,
                                videoSrc: item.filePath,
                                gifPath: item.gifPath
                            };
                        }));
                    })
                        .catch((err) => { reject(err); });
                }).catch((err) => { reject(err); });
            });
        },
        getTelecomList({ commit }) {
            return new Promise((resolve, reject) => {
                getConfig().then((res1) => {
                    const id = res1.data.stream_telecom;
                    queryTopic({ subjectId: id, phone: '17310075030' })
                        .then((res) => {
                        resolve(res1.data);
                        commit('SET_SHOW_MESSAGE', res.data.backGroundColor);
                        commit('SET_SHOWLIST', res.data.ringContentVOList.filter((i) => i.ispType === 1).map((item) => {
                            return {
                                sourceType: item.ispType,
                                id: item.ringId,
                                desc: item.ringName,
                                homePosterSrc: item.homePreviewPath,
                                title: item.ringName,
                                posterSrc: item.homePreviewPath,
                                videoSrc: item.filePath,
                                gifPath: item.gifPath
                            };
                        }));
                    })
                        .catch((err) => { reject(err); });
                }).catch((err) => { reject(err); });
            });
        },
        getCarrierType({ dispatch, commit, state }) {
            dispatch('checkMobileTrack', { type: '10', res: '', isSuccess: false, carrierName: '' });
            return new Promise((resolve, reject) => {
                checkMobile({
                    phone: state.phone,
                    pcid: Router.currentRoute.query.pcid
                })
                    .then((res) => {
                    commit('SET_CARRIER_TYPE', res.data);
                    dispatch('checkMobileTrack', {
                        type: '11',
                        res,
                        isSuccess: res.code === '0000',
                        carrierName: CarrierType.MIGU
                    });
                    resolve(res);
                })
                    .catch((err) => {
                    dispatch('checkMobileTrack', { type: '11', res: err, isSuccess: false, carrierName: '' });
                    reject(err);
                });
            });
        },
        getPackageList({ commit }, payload) {
            console.log(commit);
            return new Promise((resolve, reject) => {
                packageList(payload)
                    .then((res) => {
                    resolve(res);
                })
                    .catch((err) => {
                    reject(err);
                });
            });
        },
        handleActionApi({ rootState }, data) {
            sourceApi.actionlogApi({
                ...data,
                pid: rootState.app.selfInfo['dev-pid'],
                uid: rootState.app.selfInfo.uid,
                cookieId: rootState.app.cookieId
            });
        },
        checkMobileTrack(context, payload) {
            const { type, res, isSuccess, carrierName } = payload;
            const params = {
                h5_color_ring_order_api_event_type: type,
                is_success: isSuccess || false,
                error_code: !isSuccess ? res.code || res.resCode || res.resultCode : '',
                error_msg: JSON.stringify(res),
                carrier_name: ''
            };
            if (carrierName) {
                params.carrier_name = carrierName === '3' ? '中国移动' : res.data === '2' ? '中国联通' : '中国电信';
            }
            track([{ event_id: 'h5_color_ring_order_api_event', event_param: params }]);
        },
        // 设置前的判断
        settingPrepareCucc({ state, dispatch, commit }) {
            Toast.loading({ forbidClick: true, duration: 1500 });
            dispatch('handleActionApi', {
                isp: '',
                phone: state.phone,
                action: '999-cucc',
                interfaceName: '/checkMobile',
                resCode: '',
                resMessage: window.location.href
            });
            dispatch('checkMobileTrack', { type: '10', res: '', isSuccess: false, carrierName: '' });
            dispatch('handleActionApi', {
                isp: '',
                phone: state.phone,
                action: '10',
                interfaceName: '/checkMobile',
                resCode: '',
                resMessage: ''
            });
            checkMobile({
                phone: state.phone,
                pcid: Router.currentRoute.query.pcid
            })
                .then((res) => {
                dispatch('handleActionApi', {
                    isp: '',
                    phone: state.phone,
                    action: '11',
                    interfaceName: '/checkMobile',
                    resCode: res.code,
                    resMessage: JSON.stringify(res)
                });
                commit('SET_CARRIER_TYPE', res.data.type);
                switch (res.data.type) {
                    case CarrierType.TELECOM:
                    case CarrierType.MIGU: {
                        commit('SET_ERROR_MESSAGE', '请使用联通手机号开通');
                        Toast.fail({
                            message: '请使用联通手机号开通',
                            forbidClick: true,
                            duration: 1000
                        });
                        dispatch('checkMobileTrack', {
                            type: '11',
                            res,
                            isSuccess: res.code === '0000',
                            carrierName: res.data.type
                        });
                        commit('SET_PHONE', '');
                        break;
                    }
                    case CarrierType.CUCC: {
                        dispatch('checkMobileTrack', {
                            type: '11',
                            res,
                            isSuccess: res.code === '0000',
                            carrierName: CarrierType.CUCC
                        });
                        dispatch('orderCucc', false);
                        break;
                    }
                }
            })
                .catch((err) => { console.log(err); });
        },
        // 电信设置前的判断
        settingPrepare({ state, dispatch, commit }) {
            debugger;
            const curerntPageParams = parseUrlParams(location.href);
            dispatch('handleActionApi', {
                isp: '',
                phone: state.phone,
                action: '999',
                interfaceName: '/checkMobile',
                resCode: '',
                resMessage: window.location.href
            });
            dispatch('checkMobileTrack', { type: '10', res: '', isSuccess: false, carrierName: '' });
            dispatch('handleActionApi', {
                isp: '',
                phone: state.phone,
                action: '10',
                interfaceName: '/checkMobile',
                resCode: '',
                resMessage: ''
            });
            Toast.loading({ forbidClick: true, duration: 1500 });
            checkMobile({
                phone: state.phone,
                pcid: Router.currentRoute.query.pcid
            })
                .then((res) => {
                dispatch('handleActionApi', {
                    isp: '',
                    phone: state.phone,
                    action: '11',
                    interfaceName: '/checkMobile',
                    resCode: res.code,
                    resMessage: JSON.stringify(res)
                });
                dispatch('checkMobileTrack', {
                    type: '11',
                    res,
                    isSuccess: res.code === '0000',
                    carrierName: CarrierType.TELECOM
                });
                commit('SET_CARRIER_TYPE', res.data.type);
                switch (res.data.type) {
                    case CarrierType.CUCC:
                    case CarrierType.MIGU: {
                        commit('SET_ERROR_MESSAGE', '请使用电信手机号开通');
                        Toast.fail({
                            message: '请使用电信手机号开通',
                            forbidClick: true,
                            duration: 1000
                        });
                        commit('SET_PHONE', '');
                        dispatch('checkMobileTrack', {
                            type: '11',
                            res,
                            isSuccess: res.code === '0000',
                            carrierName: res.data.type
                        });
                        if (curerntPageParams.llgclickid) {
                            failPost({
                                clickId: curerntPageParams.llgclickid,
                                eventType: 'handle_fail',
                                failMessage: '请使用电信手机号开通'
                            });
                        }
                        break;
                    }
                    case CarrierType.TELECOM: {
                        dispatch('checkMobileTrack', {
                            type: '11',
                            res,
                            isSuccess: res.code === '0000',
                            carrierName: CarrierType.TELECOM
                        });
                        dispatch('orderTelecom', false);
                        break;
                    }
                }
            })
                .catch((err) => { console.log(err); });
        },
        // 电信订阅
        async orderTelecom({ commit, state, dispatch, rootState }) {
            // ProcessDialog()
            Toast.clear();
            Toast.loading({ forbidClick: true, duration: 1500 });
            const curerntPageParams = parseUrlParams(location.href);
            curerntPageParams.videoId = state.settingData.videoId;
            curerntPageParams.copyRightID = state.settingData.copyRightID;
            curerntPageParams.productId = state.settingData.productId;
            curerntPageParams.pcid = Router.currentRoute.query.pcid;
            // await dispatch('user/getUserToken', state.phone, { root: true })
            dispatch('checkMobileTrack', { type: '26', res: '', isSuccess: false, carrierName: CarrierType.TELECOM });
            dispatch('handleActionApi', {
                isp: CarrierType.ENUM[CarrierType.TELECOM],
                phone: state.phone,
                action: '26',
                interfaceName: '/api/telecom/package/list',
                resCode: '',
                resMessage: ''
            });
            dispatch('getPackageList', state.phone).then(async (res) => {
                dispatch('checkMobileTrack', { type: '27', res, isSuccess: res.code === '0000', carrierName: CarrierType.TELECOM });
                dispatch('handleActionApi', {
                    isp: CarrierType.ENUM[CarrierType.TELECOM],
                    phone: state.phone,
                    action: '27',
                    interfaceName: '/api/telecom/package/list',
                    resCode: res.code,
                    resMessage: JSON.stringify(res)
                });
                const presetProperties = sensors.getPresetProperties();
                const cookieId = presetProperties.identities.$identity_cookie_id;
                let status = null;
                let settingPackageId = '135999999999999000565';
                const packageId = state.settingData.productId;
                res.data?.forEach((element) => {
                    if (element.package_id === packageId) {
                        status = element.status;
                        if (status === PackageStatusType.Subscribed) {
                            settingPackageId = '135999999999999000565';
                        }
                    }
                });
                // // 进一步判断旧包存在不
                // const oldid = '135999999999999000351'
                // if (status !== PackageStatusType.Subscribed) {
                //   res.data?.forEach((element) => {
                //     if (element.package_id === oldid) {
                //       status = element.status
                //       if (status === PackageStatusType.Subscribed) {
                //         settingPackageId = '135999999999999000351'
                //       }
                //     }
                //   })
                // }
                if (status === PackageStatusType.Subscribed) {
                    // 1.一键登录的手机号是当前使用的 手机号则不需要验证码
                    // 2.没确认登陆但是已经书输入过验证码
                    // 3.已经确认登录 则不需要验证码
                    Toast.fail({
                        message: '开通失败!，您已开通此业务！',
                        forbidClick: true,
                        duration: 1500
                    });
                    if (curerntPageParams.llgclickid) {
                        failPost({
                            clickId: curerntPageParams.llgclickid,
                            eventType: 'handle_fail',
                            failMessage: '开通失败!，您已开通此业务！'
                        });
                    }
                }
                else {
                    // 没有定
                    // // H5 计费下单发起接口（一键开户）
                    dispatch('handleActionApi', {
                        isp: CarrierType.ENUM[CarrierType.TELECOM],
                        token: rootState.app.userInfo.TOKEN,
                        phone: state.phone,
                        action: '28',
                        interfaceName: '/api/telecom/openOrder',
                        resCode: '',
                        resMessage: ''
                    });
                    // H5 计费下单发起接口（一键开户）
                    dispatch('handleActionApi', {
                        isp: CarrierType.ENUM[CarrierType.TELECOM],
                        token: rootState.app.userInfo.TOKEN,
                        phone: state.phone,
                        action: '28',
                        interfaceName: '/openPorTal',
                        resCode: '',
                        resMessage: ''
                    });
                    dispatch('handleActionApi', {
                        isp: CarrierType.ENUM[CarrierType.TELECOM],
                        token: rootState.app.userInfo.TOKEN,
                        phone: state.phone,
                        action: '28',
                        interfaceName: '设置id' + state.settingData.videoId,
                        resCode: '',
                        resMessage: ''
                    });
                    dispatch('checkMobileTrack', { type: '28', res: '', isSuccess: false, carrierName: CarrierType.TELECOM });
                    // sdk订购
                    const result = await newLogin({ phone: state.phone, picd: Router.currentRoute.query.picd });
                    const token = result.data.token;
                    const sdkKey = 'YzqnS6cbXFHHMcdJheUV2x72BD3d0BmE';
                    window.iPayCallback = function (res) {
                        const { code } = res;
                        // 0000-业务受理成功
                        // 0001-业务受理失败
                        // 0002-用户取消订购
                        dispatch('checkMobileTrack', {
                            type: '32',
                            res: res,
                            isSuccess: res.code === '0000',
                            carrierName: CarrierType.TELECOM
                        });
                        dispatch('handleActionApi', {
                            isp: CarrierType.ENUM[CarrierType.TELECOM],
                            token: token,
                            phone: state.phone,
                            action: '32',
                            interfaceName: '/iPayCallback',
                            resCode: res.code,
                            resMessage: JSON.stringify(res)
                        });
                        switch (code) {
                            case '0000': {
                                Toast.success('业务受理成功!');
                                break;
                            }
                            case '0001': {
                                Toast.fail('业务受理失败');
                                if (curerntPageParams.llgclickid) {
                                    failPost({
                                        clickId: curerntPageParams.llgclickid,
                                        eventType: 'handle_fail',
                                        failMessage: '业务受理失败'
                                    });
                                }
                                break;
                            }
                            case '0002': {
                                if (curerntPageParams.llgclickid) {
                                    failPost({
                                        clickId: curerntPageParams.llgclickid,
                                        eventType: 'handle_fail',
                                        failMessage: '用户取消订购'
                                    });
                                }
                                Toast.fail('用户取消订购');
                                break;
                            }
                        }
                        console.log('支付回调', code);
                    };
                    if (!window.isInit) {
                        window.imusicSdk.init(sdkKey, async (res) => {
                            // H5 计费下单发起接口（一键开户）
                            dispatch('handleActionApi', {
                                isp: CarrierType.ENUM[CarrierType.TELECOM],
                                token: rootState.app.userInfo.TOKEN,
                                phone: rootState.app.userInfo.phone,
                                action: '40',
                                interfaceName: '/init',
                                resCode: '',
                                resMessage: ''
                            });
                            console.log(res, '合作方收到init成功回调');
                            const { pcid } = parseUrlParams(location.href);
                            window.isInit = true;
                            const data = {
                                sdk_key: sdkKey,
                                token,
                                mobile: state.phone,
                                external_trade_id: `${pcid ?? ''}` + '_' + state.settingData.videoId,
                                product_id: state.settingData.productId,
                                remark: '' // 备注
                            };
                            console.log(data);
                            const cb = (res) => {
                                dispatch('checkMobileTrack', {
                                    type: '29',
                                    res: res,
                                    isSuccess: res.code === '0000',
                                    carrierName: CarrierType.TELECOM
                                });
                                dispatch('handleActionApi', {
                                    isp: CarrierType.ENUM[CarrierType.TELECOM],
                                    token: rootState.app.userInfo.TOKEN,
                                    phone: rootState.app.userInfo.phone,
                                    action: '29',
                                    interfaceName: '/openPorTal',
                                    resCode: res.code,
                                    resMessage: JSON.stringify(res)
                                });
                                console.log('openPorTal cb', res);
                                if (res.code === '0000') {
                                    window.imusicSdk.toPay();
                                }
                                else {
                                    Toast.fail(res.message);
                                    ProcessDialog.close();
                                }
                            };
                            // 开始订购
                            console.log(data);
                            sourceApi.channelAdd({
                                mobile: state.phone,
                                type: ~~CarrierType.TELECOM,
                                promotionChannel: Router.currentRoute.query.pcid,
                                pid: rootState.app.selfInfo['dev-pid'],
                                uid: rootState.app.selfInfo.uid,
                                cookieId: cookieId,
                                url: window.location.href
                            });
                            // Toast({
                            //   type: 'loading',
                            //   duration: 1500
                            // })
                            // ProcessDialog()
                            Toast.clear();
                            ProcessDialog();
                            window.imusicSdk.openPorTal(data, cb);
                            setTimeout(() => {
                                const div = window.document.querySelector('#imusicTag');
                                handleMIGUClose(div, {}, false, { commit, state, rootState });
                            }, 200);
                        });
                    }
                    else {
                        const { pcid } = parseUrlParams(location.href);
                        const data = {
                            sdk_key: sdkKey,
                            token,
                            mobile: state.phone,
                            product_id: state.settingData.productId,
                            external_trade_id: `${pcid ?? ''}` + '_' + state.settingData.videoId,
                            remark: '' // 备注
                        };
                        console.log(data);
                        const cb = (res) => {
                            dispatch('checkMobileTrack', {
                                type: '29',
                                res: res,
                                isSuccess: res.code === '0000',
                                carrierName: CarrierType.TELECOM
                            });
                            dispatch('handleActionApi', {
                                isp: CarrierType.ENUM[CarrierType.TELECOM],
                                token: rootState.app.userInfo.TOKEN,
                                phone: rootState.app.userInfo.phone,
                                action: '29',
                                interfaceName: '/openPorTal',
                                resCode: res.code,
                                resMessage: JSON.stringify(res)
                            });
                            console.log('openPorTal cb', res);
                            if (res.code === '0000') {
                                window.imusicSdk.toPay();
                            }
                            else {
                                Toast.fail(res.message);
                                ProcessDialog.close();
                            }
                        };
                        // 开始订购
                        console.log(data);
                        sourceApi.channelAdd({
                            mobile: state.phone,
                            type: ~~CarrierType.TELECOM,
                            promotionChannel: Router.currentRoute.query.pcid,
                            pid: rootState.app.selfInfo['dev-pid'],
                            uid: rootState.app.selfInfo.uid,
                            cookieId: cookieId,
                            url: window.location.href
                        });
                        Toast.clear();
                        ProcessDialog();
                        window.imusicSdk.openPorTal(data, cb);
                        setTimeout(() => {
                            const div = window.document.querySelector('#imusicTag');
                            handleMIGUClose(div, {}, false, { commit, state, rootState });
                        }, 200);
                    }
                }
            });
        },
        // 电信设置前的判断
        settingPrepareMiddle({ state, dispatch, commit }) {
            debugger;
            const curerntPageParams = parseUrlParams(location.href);
            dispatch('handleActionApi', {
                isp: '',
                phone: state.phone,
                action: '999',
                interfaceName: '/checkMobile',
                resCode: '',
                resMessage: window.location.href
            });
            dispatch('checkMobileTrack', { type: '10', res: '', isSuccess: false, carrierName: '' });
            dispatch('handleActionApi', {
                isp: '',
                phone: state.phone,
                action: '10',
                interfaceName: '/checkMobile',
                resCode: '',
                resMessage: ''
            });
            Toast.loading({ forbidClick: true, duration: 1500 });
            checkMobile({
                phone: state.phone,
                pcid: Router.currentRoute.query.pcid
            })
                .then((res) => {
                dispatch('handleActionApi', {
                    isp: '',
                    phone: state.phone,
                    action: '11',
                    interfaceName: '/checkMobile',
                    resCode: res.code,
                    resMessage: JSON.stringify(res)
                });
                dispatch('checkMobileTrack', {
                    type: '11',
                    res,
                    isSuccess: res.code === '0000',
                    carrierName: CarrierType.TELECOM
                });
                commit('SET_CARRIER_TYPE', res.data.type);
                switch (res.data.type) {
                    case CarrierType.CUCC:
                    case CarrierType.MIGU: {
                        commit('SET_ERROR_MESSAGE', '请使用电信手机号开通');
                        Toast.fail({
                            message: '请使用电信手机号开通',
                            forbidClick: true,
                            duration: 1000,
                            onClose: () => {
                                Router.go(-1);
                            }
                        });
                        commit('SET_PHONE', '');
                        dispatch('checkMobileTrack', {
                            type: '11',
                            res,
                            isSuccess: res.code === '0000',
                            carrierName: res.data.type
                        });
                        if (curerntPageParams.llgclickid) {
                            failPost({
                                clickId: curerntPageParams.llgclickid,
                                eventType: 'handle_fail',
                                failMessage: '请使用电信手机号开通'
                            });
                        }
                        break;
                    }
                    case CarrierType.TELECOM: {
                        dispatch('checkMobileTrack', {
                            type: '11',
                            res,
                            isSuccess: res.code === '0000',
                            carrierName: CarrierType.TELECOM
                        });
                        dispatch('orderTelecomMiddle', false);
                        break;
                    }
                }
            })
                .catch((err) => { console.log(err); });
        },
        // 电信订阅
        async orderTelecomMiddle({ commit, state, dispatch, rootState }) {
            // ProcessDialog()
            Toast.clear();
            Toast.loading({ forbidClick: true, duration: 1500 });
            const curerntPageParams = parseUrlParams(location.href);
            curerntPageParams.videoId = state.settingData.videoId;
            curerntPageParams.copyRightID = state.settingData.copyRightID;
            curerntPageParams.productId = state.settingData.productId;
            curerntPageParams.pcid = Router.currentRoute.query.pcid;
            // await dispatch('user/getUserToken', state.phone, { root: true })
            dispatch('checkMobileTrack', { type: '26', res: '', isSuccess: false, carrierName: CarrierType.TELECOM });
            dispatch('handleActionApi', {
                isp: CarrierType.ENUM[CarrierType.TELECOM],
                phone: state.phone,
                action: '26',
                interfaceName: '/api/telecom/package/list',
                resCode: '',
                resMessage: ''
            });
            dispatch('getPackageList', state.phone).then(async (res) => {
                dispatch('checkMobileTrack', { type: '27', res, isSuccess: res.code === '0000', carrierName: CarrierType.TELECOM });
                dispatch('handleActionApi', {
                    isp: CarrierType.ENUM[CarrierType.TELECOM],
                    phone: state.phone,
                    action: '27',
                    interfaceName: '/api/telecom/package/list',
                    resCode: res.code,
                    resMessage: JSON.stringify(res)
                });
                const presetProperties = sensors.getPresetProperties();
                const cookieId = presetProperties.identities.$identity_cookie_id;
                let status = null;
                let settingPackageId = '135999999999999000565';
                const packageId = state.settingData.productId;
                res.data?.forEach((element) => {
                    if (element.package_id === packageId) {
                        status = element.status;
                        if (status === PackageStatusType.Subscribed) {
                            settingPackageId = '135999999999999000565';
                        }
                    }
                });
                // // 进一步判断旧包存在不
                // const oldid = '135999999999999000351'
                // if (status !== PackageStatusType.Subscribed) {
                //   res.data?.forEach((element) => {
                //     if (element.package_id === oldid) {
                //       status = element.status
                //       if (status === PackageStatusType.Subscribed) {
                //         settingPackageId = '135999999999999000351'
                //       }
                //     }
                //   })
                // }
                if (status === PackageStatusType.Subscribed) {
                    // 1.一键登录的手机号是当前使用的 手机号则不需要验证码
                    // 2.没确认登陆但是已经书输入过验证码
                    // 3.已经确认登录 则不需要验证码
                    Toast.fail({
                        message: '开通失败!，您已开通此业务！',
                        forbidClick: true,
                        duration: 1500,
                        onClose: () => {
                            Router.go(-1);
                        }
                    });
                    if (curerntPageParams.llgclickid) {
                        failPost({
                            clickId: curerntPageParams.llgclickid,
                            eventType: 'handle_fail',
                            failMessage: '开通失败!，您已开通此业务！'
                        });
                    }
                }
                else {
                    // 没有定
                    // // H5 计费下单发起接口（一键开户）
                    dispatch('handleActionApi', {
                        isp: CarrierType.ENUM[CarrierType.TELECOM],
                        token: rootState.app.userInfo.TOKEN,
                        phone: state.phone,
                        action: '28',
                        interfaceName: '/api/telecom/openOrder',
                        resCode: '',
                        resMessage: ''
                    });
                    // H5 计费下单发起接口（一键开户）
                    dispatch('handleActionApi', {
                        isp: CarrierType.ENUM[CarrierType.TELECOM],
                        token: rootState.app.userInfo.TOKEN,
                        phone: state.phone,
                        action: '28',
                        interfaceName: '/openPorTal',
                        resCode: '',
                        resMessage: ''
                    });
                    dispatch('handleActionApi', {
                        isp: CarrierType.ENUM[CarrierType.TELECOM],
                        token: rootState.app.userInfo.TOKEN,
                        phone: state.phone,
                        action: '28',
                        interfaceName: '设置id' + state.settingData.videoId,
                        resCode: '',
                        resMessage: ''
                    });
                    dispatch('checkMobileTrack', { type: '28', res: '', isSuccess: false, carrierName: CarrierType.TELECOM });
                    // sdk订购
                    const result = await newLogin({ phone: state.phone, picd: Router.currentRoute.query.picd });
                    const token = result.data.token;
                    const sdkKey = 'YzqnS6cbXFHHMcdJheUV2x72BD3d0BmE';
                    window.iPayCallback = function (res) {
                        const { code } = res;
                        // 0000-业务受理成功
                        // 0001-业务受理失败
                        // 0002-用户取消订购
                        dispatch('checkMobileTrack', {
                            type: '32',
                            res: res,
                            isSuccess: res.code === '0000',
                            carrierName: CarrierType.TELECOM
                        });
                        dispatch('handleActionApi', {
                            isp: CarrierType.ENUM[CarrierType.TELECOM],
                            token: token,
                            phone: state.phone,
                            action: '32',
                            interfaceName: '/iPayCallback',
                            resCode: res.code,
                            resMessage: JSON.stringify(res)
                        });
                        switch (code) {
                            case '0000': {
                                Toast.success('业务受理成功!');
                                break;
                            }
                            case '0001': {
                                Toast.fail({
                                    message: '业务受理失败!，您已开通此业务！',
                                    forbidClick: true,
                                    duration: 1500,
                                    onClose: () => {
                                        Router.go(-1);
                                    }
                                });
                                if (curerntPageParams.llgclickid) {
                                    failPost({
                                        clickId: curerntPageParams.llgclickid,
                                        eventType: 'handle_fail',
                                        failMessage: '业务受理失败'
                                    });
                                }
                                break;
                            }
                            case '0002': {
                                if (curerntPageParams.llgclickid) {
                                    failPost({
                                        clickId: curerntPageParams.llgclickid,
                                        eventType: 'handle_fail',
                                        failMessage: '用户取消订购'
                                    });
                                }
                                Toast.fail({
                                    message: '业务受理失败!用户取消订购',
                                    forbidClick: true,
                                    duration: 1500,
                                    onClose: () => {
                                        Router.go(-1);
                                    }
                                });
                                break;
                            }
                        }
                        console.log('支付回调', code);
                    };
                    if (!window.isInit) {
                        window.imusicSdk.init(sdkKey, async (res) => {
                            // H5 计费下单发起接口（一键开户）
                            dispatch('handleActionApi', {
                                isp: CarrierType.ENUM[CarrierType.TELECOM],
                                token: rootState.app.userInfo.TOKEN,
                                phone: rootState.app.userInfo.phone,
                                action: '40',
                                interfaceName: '/init',
                                resCode: '',
                                resMessage: ''
                            });
                            console.log(res, '合作方收到init成功回调');
                            const { pcid } = parseUrlParams(location.href);
                            window.isInit = true;
                            const data = {
                                sdk_key: sdkKey,
                                token,
                                mobile: state.phone,
                                external_trade_id: `${pcid ?? ''}` + '_' + state.settingData.videoId,
                                product_id: state.settingData.productId,
                                remark: '' // 备注
                            };
                            console.log(data);
                            const cb = (res) => {
                                dispatch('checkMobileTrack', {
                                    type: '29',
                                    res: res,
                                    isSuccess: res.code === '0000',
                                    carrierName: CarrierType.TELECOM
                                });
                                dispatch('handleActionApi', {
                                    isp: CarrierType.ENUM[CarrierType.TELECOM],
                                    token: rootState.app.userInfo.TOKEN,
                                    phone: rootState.app.userInfo.phone,
                                    action: '29',
                                    interfaceName: '/openPorTal',
                                    resCode: res.code,
                                    resMessage: JSON.stringify(res)
                                });
                                console.log('openPorTal cb', res);
                                if (res.code === '0000') {
                                    window.imusicSdk.toPay();
                                }
                                else {
                                    Toast.fail({
                                        message: res.message,
                                        forbidClick: true,
                                        duration: 1500,
                                        onClose: () => {
                                            Router.go(-1);
                                        }
                                    });
                                    ProcessDialog.close();
                                }
                            };
                            // 开始订购
                            console.log(data);
                            sourceApi.channelAdd({
                                mobile: state.phone,
                                type: ~~CarrierType.TELECOM,
                                promotionChannel: Router.currentRoute.query.pcid,
                                pid: rootState.app.selfInfo['dev-pid'],
                                uid: rootState.app.selfInfo.uid,
                                cookieId: cookieId,
                                url: window.location.href
                            });
                            // Toast({
                            //   type: 'loading',
                            //   duration: 1500
                            // })
                            // ProcessDialog()
                            Toast.clear();
                            ProcessDialog();
                            window.imusicSdk.openPorTal(data, cb);
                            setTimeout(() => {
                                const div = window.document.querySelector('#imusicTag');
                                handleMIGUClose(div, {}, false, { commit, state, rootState });
                            }, 200);
                        });
                    }
                    else {
                        const { pcid } = parseUrlParams(location.href);
                        const data = {
                            sdk_key: sdkKey,
                            token,
                            mobile: state.phone,
                            product_id: state.settingData.productId,
                            external_trade_id: `${pcid ?? ''}` + '_' + state.settingData.videoId,
                            remark: '' // 备注
                        };
                        console.log(data);
                        const cb = (res) => {
                            dispatch('checkMobileTrack', {
                                type: '29',
                                res: res,
                                isSuccess: res.code === '0000',
                                carrierName: CarrierType.TELECOM
                            });
                            dispatch('handleActionApi', {
                                isp: CarrierType.ENUM[CarrierType.TELECOM],
                                token: rootState.app.userInfo.TOKEN,
                                phone: rootState.app.userInfo.phone,
                                action: '29',
                                interfaceName: '/openPorTal',
                                resCode: res.code,
                                resMessage: JSON.stringify(res)
                            });
                            console.log('openPorTal cb', res);
                            if (res.code === '0000') {
                                window.imusicSdk.toPay();
                            }
                            else {
                                Toast.fail(res.message);
                                ProcessDialog.close();
                            }
                        };
                        // 开始订购
                        console.log(data);
                        sourceApi.channelAdd({
                            mobile: state.phone,
                            type: ~~CarrierType.TELECOM,
                            promotionChannel: Router.currentRoute.query.pcid,
                            pid: rootState.app.selfInfo['dev-pid'],
                            uid: rootState.app.selfInfo.uid,
                            cookieId: cookieId,
                            url: window.location.href
                        });
                        Toast.clear();
                        ProcessDialog();
                        window.imusicSdk.openPorTal(data, cb);
                        setTimeout(() => {
                            const div = window.document.querySelector('#imusicTag');
                            handleMIGUClose(div, {}, false, { commit, state, rootState });
                        }, 200);
                    }
                }
            });
        }
    }
};
export default introduce;
